import Vue from 'vue'
import Router from 'vue-router'
import { ifAuthenticated, ifNotAuthenticated } from '../utils/router'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      name: 'login',
      path: '/login',
      beforeEnter: ifNotAuthenticated,
      component: () => import('@/views/login/Index'),
    },
    {
      path: '/',
      component: () => import('@/views/dashboard/Index'),
      redirect: '/dashboard',
      children: [
        // Dashboard
        // {
        //   name: 'Dashboard',
        //   path: 'dashboard',
        //   beforeEnter: ifAuthenticated,
        //   component: () => import('@/views/dashboard/Dashboard'),
        // },
        // Pages
        {
          name: 'Perfil de Usuario',
          path: 'perfil',
          beforeEnter: ifAuthenticated,

          component: () => import('@/views/dashboard/pages/Perfil'),
        },
        {
          name: 'Mis Dispositivos',
          path: 'dispositivos',
          beforeEnter: ifAuthenticated,
          component: () => import('@/views/dashboard/pages/MisDispositivos'),
        },
        {
          name: 'Alarmas',
          path: 'alarmas',
          beforeEnter: ifAuthenticated,
          component: () => import('@/views/dashboard/pages/Alarmas'),
        },
        {
          name: 'Dispositivo',
          path: 'dispositivos/:codigo',
          beforeEnter: ifAuthenticated,
          component: () => import('@/views/dashboard/pages/Dispositivo'),
        },
        // {
        //   name: 'Notifications',
        //   path: 'components/notifications',
        //   beforeEnter: ifAuthenticated,
        //
        //   component: () => import('@/views/dashboard/component/Notifications'),
        // },
        // {
        //   name: 'Icons',
        //   path: 'components/icons',
        //   component: () => import('@/views/dashboard/component/Icons'),
        // },
        // {
        //   name: 'Typography',
        //   path: 'components/typography',
        //   component: () => import('@/views/dashboard/component/Typography'),
        // },
        // // Tables
        // {
        //   name: 'Regular Tables',
        //   path: 'tables/regular-tables',
        //   component: () => import('@/views/dashboard/tables/RegularTables'),
        // },
        // // Maps
        // {
        //   name: 'Google Maps',
        //   path: 'maps/google-maps',
        //   component: () => import('@/views/dashboard/maps/GoogleMaps'),
        // },
        // // Upgrade
        // {
        //   name: 'Upgrade',
        //   path: 'upgrade',
        //   component: () => import('@/views/dashboard/Upgrade'),
        // },
      ],
    },
    {
      path: '*',
      redirect: '/dispositivos',
    },
  ],
})
